import { render, staticRenderFns } from "./Vidcents.vue?vue&type=template&id=f2a6d6b2"
import script from "./Vidcents.vue?vue&type=script&lang=js"
export * from "./Vidcents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports